<template>
    <div class="tab-pane fade" id="nav-AppointmentCoaching" role="tabpanel" aria-labelledby="nav-AppointmentCoaching-tab"
        tabindex="0">
        <div class="table-responsive dashboard-table-responsive">
            <table class="table dashboard-card-table">
                <tbody>
                    <tr v-for="item in BookingCoach" :key="item.id">
                        <td>
                            <div class="academy-info academy-coach-info">
                                <router-link to="/coaches/coach-booking" class="academy-img">
                                    <img :src="require(`@/assets/img/featured/${item.Image}`)" alt="Booking">
                                </router-link>
                                <div class="academy-content">
                                    <h6><a data-bs-toggle="modal" data-bs-target="#upcoming-coach">{{item.Name}}</a></h6>
                                    <ul>
                                        <li>{{item.Court}}</li>
                                        <li><i class="feather-clock"></i> 06:00 PM to 08:00 PM</li>
                                    </ul>
                                </div>
                            </div>
                        </td>
                        <td>Date: Tue, Jul 11</td>
                        <td>
                            <div class="academy-new-icon">
                                <router-link to="/coaches/coach-booking">
                                    <i class="feather-chevron-right"></i>
                                </router-link>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import BookingCoach from '@/assets/json/coach-booking-coaching.json'
export default {
    data() {
        return {
            BookingCoach: BookingCoach
        }
    },
}
</script>